// function isValidDomain(origin, customDomain = '') {
//   // Domain and api domain
//   const params = new URLSearchParams(window.location.search);
//   const env = params.get('env') || '';
// let allowedOrigins = [
//     'https://www.gevme.com',
//     'https://showcase-dev.gevme.com',
//     'https://showcase-dev.gev.me',
//     'https://showcase.gev.me',
//     'https://live.gev.me',
//     'https://live-dev.gevme.com',
//     'https://live.gevme.com',
//     'https://admin.gevme.com',
//     'https://admin.gev.me',
//     'https://admin-dev.gevme.com',
//   ];

//   if (
//     (process.env.NODE_ENV === 'development' ||
//       process.env.NODE_ENV === 'LOCAL') &&
//     env === 'localhost'
//   ) {
//     allowedOrigins.push('http://localhost:3001');
//   }

//   if (customDomain) {
//     allowedOrigins.push(customDomain);
//   }

//   return allowedOrigins.some((domain) => origin === domain);
// }

function handleMessagePeople(event, iframeId) {
  try {
    let dataObj = JSON.parse(event.data);
    if (dataObj && dataObj.eventType === "listenerAttached") {
      document.getElementById(iframeId).contentWindow.postMessage(
        JSON.stringify({
          action: "gevme-json",
          data: JSON.stringify(window.GEVME),
        }),
        "*"
      );
    }
    if (dataObj.type) {
      let type = dataObj.type;

      if (type === "open-direct-message" || type === "meetnow") {
        var livebar = document.querySelector("iframe#GevmeLiveBar");
        if (livebar) livebar.contentWindow.postMessage(dataObj, "*");
      }

      if (type === "expand-height") {
        var peopleDirectory = document.querySelector(
          `#GevmePeopleDirectory${dataObj.blockId ? "-" + dataObj.blockId : ""}`
        );
        if (peopleDirectory) {
          peopleDirectory.style.minHeight = "unset";

          if (dataObj.minHeight)
            peopleDirectory.style.minHeight = dataObj.minHeight + "px";
          setTimeout(() => {
            peopleDirectory.style.height = dataObj.height;
          }, 200);
        }
      }
    }
  } catch (error) {}
}
class GevmePeopleDirectory extends HTMLElement {
  constructor() {
    super();
  }

  attachPeopleDirectoryMessageEvent(iframeId) {
    window.addEventListener("message", (e) => {
      if (isValidDomain(e.origin, window?.GEVME?.setting?.customDomain)) {
        handleMessagePeople(e, iframeId);
      }
    });
  }
  connectedCallback() {
    var iframe = document.createElement("iframe"),
      redirectBaseURI = `${
        window?.GEVME?.setting?.customDomain || process.env.TEMPLATE_APP_DOMAIN
      }/widgets`,
      iframeSrc = "",
      objset = {},
      isContentBlock = false,
      frameHeight = "600px",
      settings = this.getAttribute("settings"),
      type = this.getAttribute("type"),
      preview = this.getAttribute("preview"),
      fullpagepreview = this.getAttribute("fullpagepreview"),
      slug = this.getAttribute("slug"),
      iframeId = `GevmePeopleDirectory${settings ? "-" + settings : ""}`;

    try {
      if (settings && typeof settings === "string") {
        isContentBlock = true;
      } else throw "No block id provided";
    } catch (error) {
      console.error(error);
    }

    if (isContentBlock) {
      try {
        const passedId = settings;
        const showcaseBlocks = Object.values(
          window.GEVME.livepage.showcaseblocks
        );

        const peopleBlock = showcaseBlocks.find(
          ({ id, name }) => id === passedId || passedId === name
        );
        if (!peopleBlock) throw new Error("block not found");

        if (
          peopleBlock.blockHeight &&
          peopleBlock.blockHeight !== "fit-content"
        )
          frameHeight = peopleBlock.blockHeight;
        let sponsorId = window.GEVME.sponsor ? window.GEVME.sponsor.code : "";
        const pathSearchParam = window.location.href.split("path=").pop();
        if (pathSearchParam) {
          const path = decodeURIComponent(pathSearchParam.split("&")[0]);
          if (path) {
            const urlParams = new URLSearchParams(path.split("?").pop());
            const sponsorParam = urlParams.get("sponsorId");
            if(sponsorParam) {
              sponsorId = sponsorParam;
            }
          }
        }

        iframeSrc =
          `${redirectBaseURI}/people-directory?companyId=${
            window?.GEVME?.project?.companyId
          }&&projectId=${window?.GEVME?.project?.id}&livePageId=${
            window?.GEVME?.livepage?.id
          }&blockId=${peopleBlock?.id || passedId}&sponsorId=${sponsorId}` +
          `${preview === "true" ? "&isPreview=true" : ""}` +
          (fullpagepreview
            ? `&previewInXP=${fullpagepreview === "true" ? "false" : "true"}`
            : "") +
          `&slug=${window?.GEVME?.livepage?.slug}${
            type ? `&type=${type}` : ""
          }`;
      } catch (error) {
        console.error(error);
      }
    }
    iframe.id = iframeId;
    iframe.name = "GevmePeopleDirectory";
    iframe.title = "Gevme People Directory";
    iframe.sandbox =
      "allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-downloads allow-modals allow-presentation allow-same-origin";
    iframe.allowFullScreen = true;
    iframe.seamless = true;
    iframe.loading = "lazy";
    iframe.frameBorder = "0";
    iframe.referrerPolicy = "no-referrer";
    iframe.src = iframeSrc;
    iframe.style = `display: flex; width: ${
      objset && objset.width ? objset.width : "100%"
    }; height: ${frameHeight}; margin: auto;`;
    iframe.onload = function () {
      try {
        this.contentWindow.postMessage(
          JSON.stringify({
            action: "gevme-json",
            data: JSON.stringify(window.GEVME),
          }),
          "*"
        );
      } catch (error) {}
    };
    this.append(iframe);
    this.attachPeopleDirectoryMessageEvent(iframeId);
  }
}
window.customElements.define("gevme-people-directory", GevmePeopleDirectory);
